module.exports = __webpack_public_path__ + "img/bg-img2.eae6b4b4.png";